import React from 'react';

import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';

import Loading from "./loading";
// import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Paper from '@mui/material/Paper';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

//Show/Hide
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

//Date pickers
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import itLocale from 'date-fns/locale/it';
import moment from 'moment'

import debounce from "lodash/debounce";

import { styled as muiStyled } from '@mui/material/styles';

const StyledFilterCell = muiStyled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "white",
    color: "white",
    padding: "6px 2px"
  }
}));

const StyledTableCell = muiStyled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#212529",
    color: "white",
  },
  [`&.${tableCellClasses.head} .MuiTableSortLabel-root`]: {
    backgroundColor: "#212529",
    color: "white",
  },
  [`&.${tableCellClasses.head} .MuiTableSortLabel-icon.MuiSvgIcon-root`]: {
    backgroundColor: "#212529",
    color: "white",
  },
  // [`&.${tableCellClasses.body}`]: {
  //   fontSize: 14,
  // },
}));

const StyledTableRow = muiStyled(TableRow)(({ theme }) => ({
  // '&:nth-of-type(odd)': {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const StyledTablePagination = muiStyled(TablePagination)(({ theme }) => ({
  // '&:nth-of-type(odd)': {
  //   backgroundColor: theme.palette.action.hover,
  // },
  // hide last border
  '& .MuiTablePagination-selectLabel': {
    'marginBottom': 'auto',
    'marginTop': 'auto',
  },
  '& .MuiTablePagination-displayedRows': {
    'marginBottom': 'auto',
    'marginTop': 'auto',
  },
}));

const ITEM_HEIGHT = 98;
const ITEM_PADDING_TOP = 2;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    }
  },
  //getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  variant: "menu"
};

export default function GeneralTable(
  {
    buttonsMenu,
    cols,
    data,
    itemsCount,
    isLoading,
    handleChanges,
    initialOptions = {},
    generalOptions = {}
  }) {

  const [colsIn, setColsIn] = useState(cols);
  const [selected, setSelected] = useState([]);
  const [colsStartVisible, setColsStartVisible] = useState([]);
  let arrTemp = [];

  //creo l'array con le colonne che hanno visible=true all'avvio
  useEffect(() => {
    function getDefaultColsVisible() {
      setColsIn(cols);
      let items = [...cols]
      items.forEach((item) => {
        if (item?.isVisible === true && item?.label !== '') {
          arrTemp.push(item)
        }
      });
      setSelected(arrTemp);
      setColsStartVisible(arrTemp);
    }
    getDefaultColsVisible()
  }, [cols]);// eslint-disable-line react-hooks/exhaustive-deps

  const isAllSelected = colsIn.length > 0 && selected.length === colsIn.length;

  const handleChange = (event) => {
    const value = event.target.value;
    let updateColsInIsVisible = []

    if (value[value.length - 1] === "all") {
      if (selected.length === colsIn?.length) {
        setSelected([]);
        colsIn.forEach((item) => {
          if (colsStartVisible.findIndex((o) => o.key === item.key) >= 0) {
            item.isVisible = true
          }
          else {
            item.isVisible = false;
          }
          updateColsInIsVisible.push(item);
        });
        setSelected(colsStartVisible);
        setColsStartVisible(colsStartVisible)
      }
      else {
        setSelected(colsIn);
        colsIn.forEach((item) => {
          item.isVisible = true
          updateColsInIsVisible.push(item);
        })
      }
      setColsIn(updateColsInIsVisible)
      return;
    }

    setSelected(value);
    //console.log('Selezionati: ', value)

    colsIn.forEach((item) => {
      if (value.findIndex((o) => o.key === item.key) >= 0) {
        item.isVisible = true
      }
      else {
        item.isVisible = false;
      }
      updateColsInIsVisible.push(item);
    });

    setColsIn(updateColsInIsVisible)
  };

  // const [pages, setPages] = useState([]);
  // const [itemsCount, setItemsCount] = useState(0);

  const debounceTriggeredAfter = 600; //ms

  //useState(new Date('2022-02-22T00:00:00Z'));
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const {
    rowsPerPageOptions = [10, 25, 50],
    rowPkKey = 'id'
  } = generalOptions;

  const {
    initialPageNum = 1,
    initialPageSize = 10,
    initialOrdering = { key: null, asc: false },
    initialFilters = {},
  } = initialOptions;

  let _pageNum = useRef(initialPageNum - 1)
  const [pageNum, _setPageNum] = useState(_pageNum.current);
  const setPageNum = (v) => { _pageNum.current = v; _setPageNum(v) }

  let _order = useRef(initialOrdering)
  const [order, _setOrder] = useState(_order.current);
  const setOrder = (v) => { _order.current = v; _setOrder(v) }

  let _rowsPerPage = useRef(initialPageSize)
  const [rowsPerPage, _setRowsPerPage] = useState(_rowsPerPage.current);
  const setRowsPerPage = (v) => { _rowsPerPage.current = v; _setRowsPerPage(v) }

  let _filters = useRef(initialFilters)
  //eslint-disable-next-line
  const [filters, _setFilters] = useState(_filters.current);
  const setFilters = (v) => {
    _filters.current = Object.assign(_filters.current, v);
    _setFilters(Object.assign(_filters.current, v));
  }

  const handleChangePageNum = (event, newPage) => {
    setPageNum(newPage);
    _handleChanges()
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPageNum(0);
    _handleChanges()
  };

  const _handleChanges = () => {
    let params = {
      page_size: _rowsPerPage.current,
      page: _pageNum.current + 1,
      ordering: `${(!_order.current.asc) ? '-' : ''}${_order.current.key}`,
    }
    Object.assign(params, _filters.current);
    Object.assign(params, { colsOut: colsIn });
    //console.log(params)
    handleChanges(params)
  }

  const renderize = (col, row) => {
    if (col?.render) {
      return col.render(col, row)
    } else {
      return <>{row[col.key]}</>
    }
  }

  /* const uniqueData = (udata) => {
    return Array.from(new Set(udata));
  } */

  return (
    <>
      {/* <div className="container-fluid">
            <div className="row">
              <div className="col"> */}
      {isLoading && <Loading />}
      <Paper sx={{ width: '100%', overflow: 'hidden', height: '100%' }}>

        {buttonsMenu?.length > 0 && <div style={{ backgroundColor: "#00000004", margin: "2px", padding: "4px", textAlign: "end" }}>
          <ButtonGroup aria-label="button group menu">
            {buttonsMenu}
          </ButtonGroup>
        </div>}
        {
          cols.length > 6 && <div style={{ backgroundColor: "#FFFFFF", margin: "2px", padding: "4px", textAlign: "end" }}>
            <FormControl sx={{ width: 180, padding: "6px" }}>
              {/* <InputLabel id="mutiple-select-cols">Show/Hide Columns</InputLabel> */}
              <Select
                labelId="mutiple-select-cols"
                multiple
                size="small"
                variant="standard"
                displayEmpty
                value={selected}
                onChange={handleChange}
                renderValue={(selected) => {
                  return <div>Show/Hide Columns</div>
                  /* return (selected.map(col =>
                    <span key={col.key}>{col.label}, </span>
                  )); */
                }}
                MenuProps={MenuProps}
              >
                <MenuItem
                  value="all"
                >
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={
                      selected.length > 0 && selected.length < colsIn.length
                    }
                  />
                  <ListItemText
                    primary="Select All"
                  />
                </MenuItem>
                {colsIn.map((col, index) => (
                  col?.label !== '' &&
                  <MenuItem key={index} value={col}>
                    <Checkbox checked={selected.indexOf(col) > -1} />
                    <ListItemText primary={col?.label} title={col?.labelTooltip} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        }
        <div className='w-100' style={{ overflowX: 'auto' }}>
          <TableContainer style={{ maxHeight: '100%' }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {
                    colsIn.map(col => {
                      if (col?.isVisible || col?.key === 'action') {
                        if (col?.isFilterable) {
                          if (col.isFilterable?.type === 'date_range') {
                            return <StyledFilterCell key={col?.key + '-filter'} sx={col?.sxStyledFilterCell}>
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
                                <DesktopDatePicker
                                  label="START"
                                  inputFormat="dd/MM/yyyy"
                                  value={dateStart}
                                  onChange={debounce((date) => {
                                    const d = new Date(date);
                                    d.setHours(0, 0, 0, 0);
                                    if (moment(d).isValid()) {
                                      setDateStart(d);
                                      setFilters(
                                        {
                                          [col.isFilterable.filters[0]]: d
                                        });
                                      setPageNum(initialPageNum - 1);
                                      _handleChanges()
                                    }
                                  }, debounceTriggeredAfter)}
                                  renderInput={(params) =>
                                    <TextField sx={{ maxWidth: "150px", backgroundColor: "white", padding: "1px" }} {...params} />}
                                  mask='__/__/____'
                                  onError={console.log}
                                  mode='date'
                                  maxDate={new Date('2030-01-01T00:00:00')}
                                  minDate={new Date('2010-01-01T00:00:00')}
                                />
                              </LocalizationProvider>
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={itLocale}>
                                <DesktopDatePicker
                                  label="END"
                                  inputFormat="dd/MM/yyyy"
                                  value={dateEnd}
                                  onChange={debounce((date) => {
                                    const d = new Date(date);
                                    d.setHours(23, 59, 59, 0);
                                    if (moment(d).isValid()) {
                                      setDateEnd(d);
                                      setFilters(
                                        {
                                          [col.isFilterable.filters[1]]: d
                                        });
                                      setPageNum(initialPageNum - 1);
                                      _handleChanges()
                                    }
                                  }, debounceTriggeredAfter)}
                                  renderInput={(params) =>
                                    <TextField sx={{ maxWidth: "150px", backgroundColor: "white", padding: "1px" }} {...params} />}
                                  mask='__/__/____'
                                  onError={console.log}
                                  mode='date'
                                  maxDate={new Date('2030-01-01T00:00:00')}
                                  minDate={new Date('2010-01-01T00:00:00')}
                                />
                              </LocalizationProvider>
                            </StyledFilterCell>
                          }
                          return <StyledFilterCell key={col?.key + '-filter'} sx={col?.sxStyledFilterCell}>
                            <Autocomplete
                              options={col?.arrOptions || ''}
                              id={col?.label}
                              size="small"
                              freeSolo
                              autoComplete
                              sx={{ width: "100%", backgroundColor: "white" }}
                              includeInputInList
                              onChange={debounce((event, newValue) => {
                                setFilters(
                                  {
                                    [col.isFilterable.filters[0]]: newValue
                                  });
                                setPageNum(initialPageNum - 1);
                                _handleChanges()
                              }, debounceTriggeredAfter)}
                              onInputChange={debounce((event, newInputValue) => {
                                setFilters(
                                  {
                                    [col.isFilterable.filters[0]]: newInputValue
                                  });
                                setPageNum(initialPageNum - 1);
                                _handleChanges()
                              }, debounceTriggeredAfter)}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={col?.label}
                                  variant="standard"
                                />
                              )}
                            />
                          </StyledFilterCell>
                        }
                        return <StyledFilterCell key={col?.key} sx={col?.sxStyledFilterCell}></StyledFilterCell>
                      }
                      return null
                    })
                  }
                </TableRow>
              </TableHead>
              <TableHead>
                <TableRow>
                  {
                    colsIn.map(col => {
                      if (col?.isVisible || col?.key === 'action') {
                        if (col?.isSortable) {
                          return <StyledTableCell key={col?.key} sx={col?.sxStyledTableCell}
                            title={col?.labelTooltip}>
                            <TableSortLabel
                              active={col.key === order.key}
                              direction={order.asc ? 'asc' : 'desc'}
                              onClick={() => {
                                setOrder(
                                  {
                                    key: col.key,
                                    asc: col.key === order.key ? !order.asc : false
                                  }); _handleChanges()
                              }}
                              sx={{ color: "inherit" }}
                            >
                              {col?.label}
                              {/* {orderBy === headCell.id ? ( */}
                              {/* <Box
                                        component="span"
                                      // sx={visuallyHidden}
                                      >
                                        {order ? 'sorted descending' : 'sorted ascending'}
                                      </Box> */}
                              {/* ) : null} */}
                            </TableSortLabel>
                          </StyledTableCell>;
                        }
                        return <StyledTableCell key={col?.key} sx={col?.sxStyledTableCell}
                          title={col?.labelTooltip}>
                          {col?.label}
                        </StyledTableCell>
                      }
                      return null
                    })
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <StyledTableRow
                    hover
                    key={row[rowPkKey]}
                    sx={{ width: "200px" }}
                  >
                    {
                      colsIn.map(col => {
                        if (col?.isVisible || col?.key === 'action') {
                          return (
                            <TableCell component="th" scope="row" key={col.key} sx={col?.sxTableCell}>
                              {renderize(col, row)}
                            </TableCell>
                          )
                        }
                        return null
                      })
                    }
                    {/* <TableCell component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.uri}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.title}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {moment(row.updated).locale("it").format()}
                        </TableCell> */}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <StyledTablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component="div"
            //count={liveviewList.length}
            count={itemsCount || 0}
            rowsPerPage={rowsPerPage}
            page={pageNum}
            onPageChange={handleChangePageNum}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        {buttonsMenu?.length > 0 && <div style={{ backgroundColor: "#00000004", margin: "2px", padding: "4px", textAlign: "end" }}>
          <ButtonGroup aria-label="button group menu">
            {buttonsMenu}
          </ButtonGroup></div>
        }
      </Paper>
      {/* </div>
            </div>
          </div> */}
    </>
  )
}
